import { Option } from '@eiq/ui';

export enum CopyOptionsExclusionLevel{
    SelectedOnly,
    AllExceptSelected
};

export const CopyOptionsExclusionLevelOptions: Option<CopyOptionsExclusionLevel>[] = [
    {
        value: CopyOptionsExclusionLevel.SelectedOnly,
        text: 'Selected only'
    },
    {
        value: CopyOptionsExclusionLevel.AllExceptSelected,
        text: 'All except selected'
    }
];
